import type { Dealer, SubDealer } from './../../api/api-types';

export function isSubDealer(dealer: Dealer | SubDealer): dealer is SubDealer {
    return (dealer as Dealer).isSubDealer;
}

export function isParentDealer(dealer: Dealer | SubDealer): dealer is Dealer {
    return !isSubDealer(dealer);
}
